//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

//
// Hooks Angular http requests to make sure that all gateway API ajax requests are made
// with the api gateway token header set and clientId specified via a query param.
//

import { IHttpInterceptor, IQService, IRequestConfig } from 'angular';
// eslint-disable-next-line no-restricted-imports
import * as angular from 'angular';
import { Auth } from 'aws-amplify';
import _ from 'underscore';

import { CuralateAuthTokenHeader } from '@utils/sessionFetch';

import { SessionVarsService as TSessionVarsService } from 'app/services/session-vars-service';

async function getJwtToken() {
  try {
    return (await Auth.currentSession()).getIdToken().getJwtToken();
  } catch (e) {
    return undefined;
  }
}

class GatewayApiInterceptor implements IHttpInterceptor {
  constructor(
    private readonly $q: IQService,
    private readonly SessionVarsService: TSessionVarsService,
  ) {}

  // HTTP request interceptor: Called when a request is made (pre-request)
  public request = (config: IRequestConfig) => {
    const clientId = this.SessionVarsService.getClientId();

    if (this.isGatewayApiCall(config)) {
      // Add the API Gateway Token on to any request to a gateway api
      return this.$q.when(
        getJwtToken().then((jwt) => {
          if (jwt) {
            config.headers = {
              ...config.headers,
              [CuralateAuthTokenHeader]: jwt,
            };
          }
          config.params = {
            ...config.params,
            clientId,
          };
          return config;
        }),
      );
    }
    return config;
  };

  private isGatewayApiCall(config: IRequestConfig): boolean {
    const baseUrls = this.SessionVarsService.getBaseUrls();
    if (!_.isObject(baseUrls)) {
      return false;
    }

    return Object.values(baseUrls).some((gatewayBaseUrl: string) =>
      config.url.startsWith(gatewayBaseUrl),
    );
  }
}

angular
  .module('curalate')
  .service('gatewayApiInterceptor', [
    '$q',
    'SessionVarsService',
    GatewayApiInterceptor,
  ]);
